interface StrikeProps extends React.ComponentPropsWithoutRef<"span"> {}

export default function Strike({ style, children, ...props }: StrikeProps) {
  return (
    <span style={{ textDecoration: "line-through", ...style }} {...props}>
      {children}
    </span>
  );
}
